import { render, staticRenderFns } from "./marketListing.vue?vue&type=template&id=a3c963d4&scoped=true"
import script from "./marketListing.vue?vue&type=script&lang=js"
export * from "./marketListing.vue?vue&type=script&lang=js"
import style0 from "./marketListing.vue?vue&type=style&index=0&id=a3c963d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c963d4",
  null
  
)

export default component.exports